import './src/styles/global.css';
import "@fontsource/paytone-one";
import "@fontsource/inter";
import "@fontsource/inter/600.css";
import "@fontsource/inter/800.css";